<template>
  <v-container>
    <v-row>
      <v-col :cols="12" md="10" offset-md="1" lg="8" offset-lg="2">
        <v-card>
          <v-card-title>Scots Connect Family Edition: Create Login</v-card-title>
          <v-card-text v-if="term == null">Loading...</v-card-text>
          <v-card-text v-else-if="term === false">
            <p>There are no active terms for Scots Connect Family Edition. Please contact Student Development (<a href="mailto:studentdevelopment@covenant.edu">studentdevelopment@covenant.edu</a>) to find out the next time Scots Connect Family Edition will be available.</p>
          </v-card-text>
          <template v-else-if="complete">
            <v-card-text>
              <p>Your registration for the Family Edition of Scots Connect is now complete! Click the button below to return to the login screen so you can log in, making sure to select the Parent Login in the dropdown.</p>
            </v-card-text>
            <v-card-actions>
              <v-btn color="success" to="/">Proceed to login screen</v-btn>
            </v-card-actions>
          </template>
          <template v-else-if="term !== ''">
            <v-card-text>
              <p>This is where parents can create an account for Scots Connect to access the orientation information for parents.</p>
            </v-card-text>
            <v-stepper v-model="step">
              <v-stepper-header>
                <v-stepper-step :complete="step > 1" step="1">Profile</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 2" step="2">Verify</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="3">Final Setup</v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-card>
                    <v-form v-model="formModel" ref="form">
                      <v-row>
                        <v-col :cols="12" md="6" style="padding-bottom:0;margin-top:10px">
                          <v-text-field v-model="firstName" :rules="required" label="First Name" outlined></v-text-field>
                        </v-col>
                        <v-col :cols="12" md="6" style="padding-bottom:0;margin-top:10px">
                          <v-text-field v-model="lastName" :rules="required" label="Last Name" outlined></v-text-field>
                        </v-col>
                        <v-col :cols="12" style="padding-top:0">
                          <v-text-field v-model="email" :rules="emailRules" label="Email (this will be what you use to log into Scots Connect)" type="email" outlined></v-text-field>
                        </v-col>
                        <v-col :cols="12" md="6" style="padding-bottom:0;padding-top:0">
                          <v-text-field v-model="studentFirstName" :rules="required" label="Student's First Name" outlined></v-text-field>
                        </v-col>
                        <v-col :cols="12" md="6" style="padding-bottom:0;padding-top:0">
                          <v-text-field v-model="studentLastName" :rules="required" label="Student's Last Name" outlined></v-text-field>
                        </v-col>
                        <v-col :cols="12" style="padding-bottom:0;padding-top:0">
                          <v-text-field v-model="studentEmail" :rules="covEmailRules" label="Student's Covenant Email" outlined></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                    <v-card-actions>
                      <v-btn color="primary" @click="checkProfile">Next</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn outlined to="/">Cancel</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-stepper-content>
                <v-stepper-content step="2">
                  <v-card>
                    <v-card-text>
                      <p>Before we proceed, we need to verify your email address. An email was just sent to you from studentdevelopment@covenant.edu with a subject of "Scots Connect Code" which contains a one-time-use code. Please log into your email to retrieve that code and copy-and-paste it below. Note that the code expires one hour from when the email was sent.</p>
                      <v-text-field v-model="oneTimeCode" label="Code from Email" outlined></v-text-field>
                      <v-alert v-if="validated === false" type="error">The code that you entered was not valid. Please ensure that you copy the whole code and that it has not expired. If you need to generate a new code, please click the "Back" button below then press "Next" again to generate a new code.</v-alert>
                    </v-card-text>
                    <v-row>
                      <v-col></v-col>
                    </v-row>
                    <v-card-actions>
                      <v-btn @click="step--">Back</v-btn>
                      <v-btn color="success" @click="verifyCode">Next</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn outlined to="/">Cancel</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-stepper-content>
                <v-stepper-content step="3">
                  <v-card>
                    <v-row>
                      <v-col cols="12">
                        <p>Your password must be at least 8 characters long and must contain at least one lower-case letter, one capital letter, and one number.</p>
                      </v-col>
                      <v-col :cols="12" md="6" style="padding-bottom:0;padding-top:0">
                        <v-text-field v-model="password" :rules="passwordRule" label="Password" type="password" outlined></v-text-field>
                      </v-col>
                      <v-col :cols="12" md="6" style="padding-bottom:0;padding-top:0">
                        <v-text-field v-model="password2" :rules="secondPasswordCheck" label="Repeat Password" type="password" outlined></v-text-field>
                      </v-col>
                    </v-row>
                    <v-card-actions>
                      <v-btn @click="step--">Back</v-btn>
                      <v-btn color="success" @click="createAccount">Create Account</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn outlined to="/">Cancel</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { onMounted, ref } from '@vue/composition-api'
export default {
  setup (props, { root }) {
    const step = ref(1)
    const formModel = ref(null)
    const form = ref(null)
    const firstName = ref('')
    const lastName = ref('')
    const email = ref('')
    const password = ref('')
    const password2 = ref('')
    const studentFirstName = ref('')
    const studentLastName = ref('')
    const studentEmail = ref('')

    const required = ref([v => !!v || 'Required'])
    const emailRules = ref([v => !!v || 'Required', v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Invalid email'])
    const covEmailRules = ref([v => !!v || 'Required', v => /^[a-z]+\.[a-z]+@covenant\.edu$/i.test(v) || 'Must be a valid Covenant email address'])
    const passwordRule = ref([
      v => v.length >= 8 || 'Must be at least 8 characters long',
      v => /[a-z]/.test(v) || 'Must contain a lower-case letter',
      v => /[A-Z]/.test(v) || 'Must contain an upper-case letter',
      v => /[\d]/.test(v) || 'Must contain a number'
    ])
    const secondPasswordCheck = ref([v => v === password.value || 'Passwords do not match'])
    const term = ref(null)

    onMounted(() => {
      // Look up to make sure there is an active Scots Connect Family Edition term
      root.$feathers.service('orientation/term').find({ query: { openDate: { $lte: new Date() }, startDate: { $gte: new Date() }, category: 'Family' } }).then(({ data }) => {
        if (data.length > 0) {
          term.value = data[0].term
        } else {
          term.value = false
        }
      })
    })

    async function checkProfile () {
      if (form.value.validate()) {
        // Submit the data to the server which will generate a unique code a
        let obj = {
          first: firstName.value,
          last: lastName.value,
          email: email.value.toLowerCase(),
          stuFirst: studentFirstName.value,
          stuLast: studentLastName.value,
          stuEmail: studentEmail.value,
          term: term.value
        }
        await root.$feathers.service('orientation/parent').create(obj)
        step.value++
      }
    }

    const oneTimeCode = ref('')
    const validated = ref(null)
    async function verifyCode () {
      validated.value = null
      try {
        const res = await root.$feathers.service('system/unique-code').find({ query: { email: email.value.toLowerCase(), code: oneTimeCode.value.trim() } })
        if (res.valid) {
          step.value++
        } else {
          validated.value = false
        }
      } catch (e) {
        validated.value = false
      }
    }

    const complete = ref(false)
    async function createAccount () {
      if (form.value.validate()) {
        let obj = {
          first: firstName.value,
          last: lastName.value,
          email: email.value.toLowerCase(),
          stuFirst: studentFirstName.value,
          stuLast: studentLastName.value,
          stuEmail: studentEmail.value,
          uniqueCode: oneTimeCode.value,
          password: password.value,
          term: term.value
        }
        await root.$feathers.service('orientation/parent').create(obj)
        complete.value = true
      }
    }

    return {
      step,
      formModel,
      form,
      firstName,
      lastName,
      email,
      password,
      password2,
      studentFirstName,
      studentLastName,
      studentEmail,
      required,
      emailRules,
      covEmailRules,
      passwordRule,
      secondPasswordCheck,
      term,
      checkProfile,
      oneTimeCode,
      validated,
      verifyCode,
      complete,
      createAccount
    }
  }
}
</script>
